import React from 'react';
import TEXT from '../Text';
import { FiatAmountInput } from '../FormFields';
import './style.scss';
import { identity } from "../../../utils/getIdentity";
import { useTranslation } from "react-i18next";

const WithdrawalSetting = ({ name }) => {
  const { t } = useTranslation();
  return (
    <div className={`withdrawal-setting withdrawal-setting-${identity}`}>
      <TEXT.sectionTitle>{t('admin.withdrawal_settings')}</TEXT.sectionTitle>
      <TEXT.sectionDescription className={`system-fee-switcher__description system-fee-switcher__description-${identity}`}>
        {t('admin.set_withdrawal')}
      </TEXT.sectionDescription>
      <FiatAmountInput
        name={name}
        className="withdrawal-setting__input"
        rules={[
          {
            validator: (rule, value) => {
              if (value === 0) {
                return Promise.reject(t('admin.minimum_withdrawal_amount'));
              }
              return Promise.resolve();
            },
          },
        ]}
      />
    </div>
  )
};

export default WithdrawalSetting;
